const lang = document.querySelector('html').getAttribute('lang')
let localeTexts

import(`Locale/${lang}`).then((module) => {
    localeTexts = module.Copy
})

export const initCopyTexts = () => {
    for (const copyTextEl of document.querySelectorAll('.js-copy-text:not(.has-copy-initialized)')) {
        copyTextEl.addEventListener('click', (event) => {
            event.preventDefault()

            navigator.clipboard.writeText(copyTextEl.dataset.text).then(() => {
                Eshop.alert(localeTexts.success, {
                    theme: 'success',
                    zIndex: 300
                })
            });
        })

        copyTextEl.classList.add('has-copy-initialized')
    }
}